import { useEffect, useRef } from 'react';
import { localTime } from '@helpers';
import { DATE_FORMAT } from '@v2/pages/common/constants/base.constants';
import { WALLBOARD_DATE_AT_MIDNIGHT_CHECK_INTERVAL_MS } from '@components/wallboard/constants';

export interface UseRollWallboardDateAtMidnightParams {
  wallboardTimelineEndDate: string;
  setWallboardTimelineEndDate: (date: string) => void;
}

const useRollWallboardDateAtMidnight = ({ wallboardTimelineEndDate, setWallboardTimelineEndDate }: UseRollWallboardDateAtMidnightParams) => {
  const endDateRef = useRef(wallboardTimelineEndDate);
  endDateRef.current = wallboardTimelineEndDate;

  const setterRef = useRef(setWallboardTimelineEndDate);
  setterRef.current = setWallboardTimelineEndDate;

  useEffect(() => {
    let currentDay = localTime().format(DATE_FORMAT);

    const intervalId = setInterval(() => {
      const today = localTime().format(DATE_FORMAT);
      if (today === currentDay) return;

      const prevEndDate = endDateRef.current;
      const wasTrackingToday = prevEndDate ? localTime(prevEndDate).format(DATE_FORMAT) === currentDay : false;

      currentDay = today;

      if (wasTrackingToday) {
        setterRef.current(localTime().format());
      }
    }, WALLBOARD_DATE_AT_MIDNIGHT_CHECK_INTERVAL_MS);

    return () => clearInterval(intervalId);
  }, []);
};

export default useRollWallboardDateAtMidnight;
